export const LOGIN_PAGE_URL = '/login';
